import {BehaviorSubject, combineLatest, distinctUntilChanged, filter, forkJoin, from, map, Subject, switchMap} from 'rxjs';
import {div} from '@px/helper/num';
import {premiumApi} from '@px/api/premium';
import {isLogin$} from './auth';
import {contractDefaultTakerFeeRateEr$} from './config';
import {wwData$} from './worker-data';

interface ProfileInfo {
  contractMakerFeeEr: number;
  contractTakerFeeEr: number;
  spotMakerFeeEr: number;
  spotTakerFeeEr: number;
  vipLevel: number;
  effectiveLevel: number;
  levelName: string;
}

interface VipFeeConfig {
  contMakerFeeEr: number;
  contTakerFeeEr: number;
  level: number;
  levelName: string;
  lowerContMakerRatio: string;
  lowerContTrdVol: string;
  lowerContVolRatio: string;
  lowerSpotMakerRatio: string;
  lowerSpotTrdVol: string;
  spotMakerFeeEr: number;
  spotTakerFeeEr: number;
  upperContApiRatio: string;
  upperSpotApiRatio: string;
}

const defaultVipProfile = {
  vipLevel: 0,
  effectiveLevel: 0,
  contractMakerFeeEr: 0,
  contractTakerFeeEr: 0,
  spotMakerFeeEr: 0,
  spotTakerFeeEr: 0,
  levelName: '--',
  tryConfig: {
    spotMakerFeeEr: 0,
    spotTakerFeeEr: 0,
    levelName: '--',
  },
};

export const vipProfileQuery$ = new Subject<void>();
export const vipProfile$ = new BehaviorSubject<ProfileInfo>(defaultVipProfile);
export const loadUsdtVipFeeConfigs$ = new Subject<void>();
const usdtVipFeeConfigs$ = new BehaviorSubject<VipFeeConfig[]>([]);
const defaultVipFeeConfig$ = new BehaviorSubject<VipFeeConfig>({
  contMakerFeeEr: 0,
  contTakerFeeEr: 0,
  level: 0,
  levelName: '',
  lowerContMakerRatio: '',
  lowerContTrdVol: '',
  lowerContVolRatio: '',
  lowerSpotMakerRatio: '',
  lowerSpotTrdVol: '',
  spotMakerFeeEr: 0,
  spotTakerFeeEr: 0,
  upperContApiRatio: '',
  upperSpotApiRatio: '',
});
combineLatest([usdtVipFeeConfigs$, vipProfileQuery$.pipe(switchMap(() => forkJoin(premiumApi.getVipProfile(), premiumApi.getVipFeeConfig({currency: 'TRY'}))))]).subscribe(
  ([usdtConfigs, [pro, tryConfigs]]) => {
    const tryConfigs2 = (tryConfigs?.data && tryConfigs?.data?.rows) || [];
    if (pro.data && usdtConfigs && usdtConfigs.length > 0) {
      const usdtConfig = usdtConfigs.find((d) => d.level === pro?.data?.vipLevel);
      const tryConfig = tryConfigs2.find((d) => d.level === pro?.data?.vipLevel);
      vipProfile$.next({...defaultVipProfile, ...(pro?.data || {}), ...(usdtConfig || {}), tryConfig});
    }
  }
);

loadUsdtVipFeeConfigs$
  .pipe(
    switchMap(() => premiumApi.getVipFeeConfig({currency: 'USDT'})),
    map(({data}) => data && data.rows),
    filter(Boolean)
  )
  .subscribe((o) => {
    const defaultVipFeeConfig = o.find((o) => o.level === 0) || {};
    defaultVipFeeConfig && defaultVipFeeConfig$.next(defaultVipFeeConfig);
    usdtVipFeeConfigs$.next(o);
  });

isLogin$.pipe(filter(Boolean)).subscribe(() => vipProfileQuery$.next());

// 默认 taker 手续费比例，一般当作一次交易的手续费
defaultVipFeeConfig$
  .pipe(
    map((o) => Number(div(o.contTakerFeeEr || 0, 1e8))),
    distinctUntilChanged()
  )
  .subscribe((contractDefaultTakerFeeRateEr) => {
    contractDefaultTakerFeeRateEr$.next(contractDefaultTakerFeeRateEr);
    wwData$.next({
      type: 'contract-default-taker-fee-rate',
      contractDefaultTakerFeeRateEr,
    });
  });
